import Moment from 'moment-timezone';

import type { Caller } from '@/models/caller';

export const dobStringToMonthDayYear = (dob: string | null | undefined): { dobMonth: number; dobDay: number; dobYear: number } | null => {
  if (!dob?.trim()) {
    return null;
  }

  const parsed = Moment.utc(dob.trim());
  if (!parsed.isValid()) {
    return null;
  }

  return {
    dobYear: parsed.year(),
    dobMonth: parsed.month() + 1,
    dobDay: parsed.date(),
  };
};

export const callerWithDobParts = (caller: Caller): Caller => {
  if (!caller?.dob) {
    return caller;
  }

  const parts = dobStringToMonthDayYear(caller.dob);
  if (!parts) {
    return caller;
  }

  return {
    ...caller,
    ...parts,
  };
};
